<template>
  <div class="ce-mix" :class="{ 'ce-mix--compact': compact }">
    <!-- The worst severity is kept, because sorting, filtering and the alarms
         all use it. A serious alert must never look minor. -->
    <a-tag class="ce-mix__worst" :style="{ backgroundColor: worstColor, borderColor: worstColor }">
      {{ worstLabel }}
    </a-tag>
    <!-- No mix means the row has not been recounted yet. Four zeroes would be a
         lie, so nothing is drawn beside the worst severity. -->
    <span v-if="parts.length" class="ce-mix__counts" :title="mixText" :aria-label="mixText">
      <span v-for="(part, i) in parts" :key="part.key" class="ce-mix__part" :style="{ color: part.color }">
        <span v-if="i" class="ce-mix__sep" aria-hidden="true">·</span>
        <template v-if="!compact">{{ part.label }} </template>
        <b>{{ formatCount(part.count) }}</b>
      </span>
    </span>
  </div>
</template>

<script>
  import { severityColor, severityMixText, severityLabel } from '../consts/ChangeEvents.consts';

  export default {
    name: 'SeverityMix',
    props: {
      /** The worst severity of the change event, as the API sent it. */
      severity: {
        type: String,
        default: ''
      },
      /**
       * The mix, already read by `severityMix()`. `null` when the API sent
       * none — the worst severity is then shown on its own.
       */
      mix: {
        type: Array,
        default: null
      },
      /** Numbers only, for a table row. Off gives `HIGH 1 · MEDIUM 12`. */
      compact: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      parts() {
        return Array.isArray(this.mix) ? this.mix : [];
      },
      worstColor() {
        return severityColor(this.severity);
      },
      worstLabel() {
        return severityLabel(this.severity);
      },
      mixText() {
        return severityMixText(this.parts);
      }
    },
    methods: {
      formatCount(value) {
        return Number(value).toLocaleString('en-US');
      }
    }
  };
</script>

<style lang="scss" scoped>
  .ce-mix {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;

    // In a table row the chip sits above the counts, so a narrow column still
    // reads in one glance.
    &--compact {
      display: block;
    }
    &__worst.ant-tag {
      color: #ffffff;
      font-size: 10px;
      margin-right: 0;
    }
    &__counts {
      font-size: 11.5px;
      white-space: nowrap;
    }
    &--compact &__counts {
      display: block;
      margin-top: 3px;
    }
    &__sep {
      color: #8a94a0;
      margin: 0 3px;
    }
    &__part b {
      font-weight: 700;
    }
  }
</style>
